import { takeEvery, all, call, put } from 'redux-saga/effects';
import { push } from 'connected-react-router';
import { SweetAlertResult } from 'sweetalert2';
import apiService from 'app/bff/services/apiService';
import { PolicyPodetailResp } from 'app/bff/models/policy/policyPodetail';
import { PolicyTravelPocancelResp } from 'app/bff/models/policy/policyTravelPocancel';
import { ROUTES } from 'app/core/router/paths';
import { combinePathWithParams } from 'app/core/router/service';
import modalService from 'app/core/services/modalService';
import { sagaBoundary } from 'app/store/service';
import {
  CancelPolicyAction,
  FetchPolicyDetailAction,
  SERVICE_QUERT_POLICY_DETAIL__CANCEL_POLICY,
  SERVICE_QUERT_POLICY_DETAIL__FETCH_POLICY_DETAIL,
  SERVICE_QUERT_POLICY_PROTECT_DETAIL__FETCH_POLICY_DETAIL
} from './types';
import { fetchPolicyDetailDoneAction, fetchPolicyProtectDetailDoneAction } from './actions';

/**
 * @description 取得保單明細
 */
function * fetchPolicyDetail (action: FetchPolicyDetailAction) {
  const response: PolicyPodetailResp['policyTravel'] = yield call(apiService.postPolicyPodetail, action.payload.args);
  if (response) {
    // 取得保單明細 完成
    yield put(fetchPolicyDetailDoneAction(response));
    // 導頁至保單查詢明細頁 (透過路由帶入資料)
    const pathName = combinePathWithParams({ path: ROUTES.SERVICE__QUERY_POLICY__DETAIL, params: { policyNo: response.policyNo } });
    const state = { detail: response, isCancel: action.payload.isCancel };
    yield put(push(pathName, state));
  }
}

/**
 * @description 取消保單
 */
function * cancelPolicy (action: CancelPolicyAction) {
  const response: PolicyTravelPocancelResp = yield call(apiService.postPolicyTravelPocancel, action.payload.args);
  if (response) {
    const result: SweetAlertResult = yield modalService.base(action.payload.successMessageTitle, action.payload.successMessageContent, '回首頁');
    if (result) yield put(push(ROUTES.HOME__MAIN));
  }
}

function * fetchPolicyProtectDetail (action: FetchPolicyDetailAction) {
  const response: PolicyPodetailResp['policyProtect'] = yield call(apiService.postPolicyProtectPodetail, action.payload.args);
  if (response) {
    // 取得保單明細 完成
    yield put(fetchPolicyProtectDetailDoneAction(response));
    // 導頁至保單查詢明細頁 (透過路由帶入資料)
    const pathName = Object.entries({ policyNo: response.policyNo }).reduce((path: string, [param, value]) => path.replace(`:${param}`, value), ROUTES.SERVICE__QUERY_POLICY_PROTECT__DETAIL);
    const state = { protectDetail: { ...response, insuranceName: action.payload.args.insuranceName }, isCancel: action.payload.isCancel };
    yield put(push(pathName, state));
  }
}

export default function * watchDetailSaga () {
  yield all([
    takeEvery(SERVICE_QUERT_POLICY_DETAIL__FETCH_POLICY_DETAIL, sagaBoundary(fetchPolicyDetail)),
    takeEvery(SERVICE_QUERT_POLICY_PROTECT_DETAIL__FETCH_POLICY_DETAIL, sagaBoundary(fetchPolicyProtectDetail)),
    takeEvery(SERVICE_QUERT_POLICY_DETAIL__CANCEL_POLICY, sagaBoundary(cancelPolicy))
  ]);
}
